import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import { InputTypes, validFormElementValue } from '../../utils/validateFormElement';
import { Events } from '../../utils/dom/html-events';
import intlTelInput from 'intl-tel-input';

class ContactNumber extends FormComponent {
	init(questionData) {
		this.renderInputField(questionData);
	}
	markup(value, data = {}, titleMarkup) {
		// NOTE: shouldRender is a method that can be overridden by the question type to implement logic to show / hide the question.
		// Currently only SessionPlayersList overrides this method to show/hide the question based on the number of players in the session.
		const shouldNotRender = !this?.shouldRender?.();

		this.inputFieldContainerClass = `lta-contact-number-input-field-container-${data.id}`;
		this.inputID = `lta-contact-number-input-field-id-${data.id}`;
		const placeholderText = data.placeHolder || '';
		const inputValue = data.value || '';
		const inputType = data.type || 'tel';
		const inputName = `lta-contact-number-input-field-name-${data.id}`;
		const fullWidthInputWrappwer = !shouldNotRender ? 'full-width' : '';
		return `
			<div class="lta-contact-number-input-field">
				<div class="lta-contact-number-input-field-title">${titleMarkup}</div>
				<div class="lta-contact-number-input__field-wrapper ${shouldNotRender ? 'u-hidden' : `${fullWidthInputWrappwer}`}">
					${this.renderSubQuestion(data.subQuestion)}
					${this.renderInstructionLabel(data?.instructionStyleClass, data.instructionText)}
					<div class="lta-text-input__wrapper ${this.inputFieldContainerClass} u-mb-3">
						${this.renderLabel(this.inputID)}
						<div class="lta-text-input--error"></div>
						<input 
							type="${inputType}"
							class="lta-text-input u-mb-3 u-w-100" 
							id="${this.inputID}"
							name="${inputName}" 
							placeholder="${placeholderText}"
							value="${inputValue}" 
						/>
					</div>
					${this.data?.showSeperator ? `<hr class="lta-form__section-separator u-my-3"/>` : ``}
				</div>
			</div>
		`;
	}

	renderLabel(inputID) {
		return this.data.titlePattern
			? ``
			: `<label for=${inputID} class="lta-text-input__label u-text-grey-lta">${this.data.label}</label>`;
	}

	renderSubQuestion(subQuestion) {
		return subQuestion ? `<div class="u-body1 u-fw-bold u-mb-1">${subQuestion}</div>` : '';
	}

	renderInstructionLabel(instructionStyleClass, instructionLabel) {
		return instructionLabel
			? `<div class="u-mb-3">
					<span class="lta-contact-number-input-field__label-instruction ${instructionStyleClass ? instructionStyleClass : ''}">
						${instructionLabel}
					</span>
				</div>`
			: '';
	}

	afterRender() {
		this.componentElement = SelectorEngine.findOne('.lta-contact-number-input-field', this._element);
		this.inputFieldContainerElement = SelectorEngine.findOne(`.${this.inputFieldContainerClass}`, this._element);
		this.inputFieldElement = SelectorEngine.findOne(`#${this.inputID}`, this.inputFieldContainerElement);

		// default true
		this.showCountryCode = this.data?.showCountryCode !== false;

		if (this.showCountryCode) {
			this.countryCodeInput = intlTelInput(this.inputFieldElement, {
				preferredCountries: ['gb'],
				separateDialCode: true
			});
		}

		EventHandler.on(this.inputFieldElement, 'input', () => {
			this.inputFieldElement.value = this.inputFieldElement.value.replace(/[^0-9]/g, '');
		});

		if (this.data?.value) {
			setTimeout(() => {
				this.handleInput();
			}, 100);
		}

		EventHandler.on(this.inputFieldElement, Events.Blur, () => {
			this.handleInput();
		});
	}

	handleInput() {
		this.inputValue = this.inputFieldElement.value;
		this.validate();

		if (this.inputValue) {
			let phoneNumber = this.inputValue;

			// If showCountryCode is true, we need to get the full phone number with country code from the intlTelInput instance 
			// and pass it to the value, so that it can be used in the dependent question if needed.
			// If showCountryCode is false, we will just pass the input value as it is.
			// for Bug 33885 - we are adding this check if we want to show country code or not,
			// as for household project we want emergency number without country code.
			if (this.showCountryCode && this.countryCodeInput) {
				phoneNumber =
					'+' +
					this.countryCodeInput.getSelectedCountryData().dialCode +
					this.inputValue;
			}

			this.value = {
				...this.data,
				value: phoneNumber
			};
		}
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}

	validate() {
		if (this?.shouldRender?.() === false) {
			return true;
		}

		const formElementData = {
			hasIcon: false,
			type: this.data?.type,
			formElement: this.inputFieldElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			element: this.inputFieldContainerElement,
			minLength: this.data?.minLength,
			minLengthErrorMessage: this.data?.minLengthErrorMessage,
			maxCharLimit: this.data?.maxLength,
			maxCharErrorMessage: this.data?.maxLengthErrorMessage
		};

		return this.data?.isOptional ? true : validFormElementValue(this.inputValue, formElementData);
	}
}
export default ContactNumber;
